import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiSearchparticipantSearchparticipantsMutationRequest,
  PostApiSearchparticipantSearchparticipantsMutationResponse,
} from "../../../types/PostApiSearchparticipantSearchparticipants";

export function getPostApiSearchparticipantSearchparticipantsUrl() {
  return `/api/SearchParticipant/SearchParticipants` as const;
}

/**
 * {@link /api/SearchParticipant/SearchParticipants}
 */
export async function postApiSearchparticipantSearchparticipants(
  data?: PostApiSearchparticipantSearchparticipantsMutationRequest,
  config: Partial<
    RequestConfig<PostApiSearchparticipantSearchparticipantsMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiSearchparticipantSearchparticipantsMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiSearchparticipantSearchparticipantsMutationRequest
  >({
    method: "POST",
    url: getPostApiSearchparticipantSearchparticipantsUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
